<template>
  <vx-card class="project-guide mb-base">
    <template slot="no-body">
      <div
        class="flex items-center justify-between px-6 py-4 cursor-pointer"
        @click="collapsed = !collapsed"
      >
        <h5 class="font-semibold flex items-center">
          <feather-icon icon="BookOpenIcon" svgClasses="h-5 w-5" class="mr-2" />
          Proje Ekleme Rehberi
        </h5>
        <feather-icon
          :icon="collapsed ? 'ChevronDownIcon' : 'ChevronUpIcon'"
          svgClasses="h-5 w-5"
        />
      </div>

      <div v-show="!collapsed" class="px-6 pb-6 guide-body">
        <h6>1. Nasıl eklenir?</h6>
        <p>
          Üstteki <b>Proje Yönetimi</b> panelinden <b>Yeni Proje Ekle</b>'ye
          tıklayın; adı, adresi, görseli ve kimlerin göreceğini seçip kaydedin.
          Mevcut kartlar aynı yerden düzenlenir veya tek tıkla pasife alınır.
          Veritabanına girmek, kod değişikliği veya deploy gerekmez; kullanıcı
          sayfayı yenilediğinde değişiklik görünür.
        </p>

        <h6>2. Kimler görür?</h6>
        <ul>
          <li>
            <b>Öğrenciler (TÖMER dahil)</b> işaretliyse öğrenci hesapları görür.
          </li>
          <li>
            <b>Akademisyen ve personel</b> işaretliyse akademik ve idari
            personel görür. Herkesin görmesi için ikisini de işaretleyin.
          </li>
          <li>
            <b>Rol kısıtı</b> (Gelişmiş ayarlar) doluysa kart yalnızca o
            uygulamada rolü olanlara görünür. Değer, rol adının ilk parçasıdır:
            <code>CarParking.User.ApplicationForm.Any</code> rolü için
            <code>CarParking</code>. Boşsa rol kısıtı olmaz.
          </li>
          <li>
            <b>Pasif</b> kartları kullanıcılar görmez; yalnızca superadminler
            bu sayfadaki <b>Pasif Projeler</b> panelinde görür. Kartı kaldırmak
            için silmek yerine pasife alın; gerektiğinde tek tıkla geri açılır.
          </li>
        </ul>

        <h6>3. Açılış şekilleri</h6>
        <ul>
          <li>
            <b>Bağlantı:</b> Yazılan adres yeni sekmede açılır. Çoğu durumda
            doğru seçim budur. Örn. <code>https://lms.fsm.edu.tr/lisanstalep</code>
          </li>
          <li>
            <b>Otomatik giriş (SSO):</b> Kullanıcı hedef sisteme giriş yapmış
            olarak gönderilir. Hedef sistem tarafında da entegrasyon gerektirir;
            yazılım ekibiyle birlikte kurulmalıdır. Site alan adı, dönüş
            adresinin alan adıyla aynı olmalıdır (form bunu kontrol eder).
          </li>
          <li>
            <b>Açılır pencere:</b> Girilen HTML içeriği portal içinde bir
            pencerede gösterilir (ör. iframe gömmek için).
          </li>
          <li>
            <b>Tam adres:</b> Eski kayıtlarla uyumluluk için; yeni kartlarda
            <b>Bağlantı</b> kullanın.
          </li>
        </ul>

        <h6>4. Görsel</h6>
        <ul>
          <li>
            <b>Görsel yükle</b> ile seçilen dosya doğrudan kaydedilir; sunucuya
            dosya koymak veya deploy gerekmez. En fazla 1 MB.
          </li>
          <li>
            Alternatif olarak harici bir https adresi veya
            <code>/logos/dosya.svg</code> yazılabilir.
          </li>
          <li>Kartlar beyaz zeminli; şeffaf arka planlı SVG/PNG en iyi sonucu verir.</li>
        </ul>

        <h6>5. Sıralama</h6>
        <p>
          Kartlar eklenme sırasına göre yeniden eskiye sıralanır; yeni eklenen
          kart en başta görünür.
        </p>

        <h6>6. Superadmin yetkisi</h6>
        <p>
          Proje Yönetimi'ni, bu rehberi ve Pasif Projeler panelini yalnızca
          <code>LoginPortal.User.Superadmin</code> rolüne sahip kullanıcılar
          görür. Rol, RoleManagement uygulamasından atanır veya kaldırılır.
        </p>
      </div>
    </template>
  </vx-card>
</template>

<script>
export default {
  name: "ProjectGuide",
  data() {
    return {
      collapsed: true,
    };
  },
};
</script>

<style lang="scss" scoped>
.project-guide {
  border-left: 4px solid #165e9e;

  .guide-body {
    line-height: 1.6;

    h6 {
      font-weight: 600;
      margin: 1.25rem 0 0.5rem;
    }

    ul {
      list-style: disc;
      padding-left: 1.5rem;

      li {
        margin-bottom: 0.25rem;
      }
    }

    code {
      background: rgba(0, 0, 0, 0.06);
      border-radius: 4px;
      padding: 0 4px;
      font-size: 0.9em;
    }

    pre {
      background: rgba(0, 0, 0, 0.06);
      border-radius: 8px;
      padding: 0.75rem 1rem;
      overflow-x: auto;
      font-size: 0.85em;
      margin: 0.5rem 0;
    }
  }
}
</style>
